package com.jingfangpai.common.data.serializer

import com.jingfangpai.common.data.type.BigDecimal
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder

@Serializer(forClass = BigDecimal::class)
actual class BigDecimalSerializer : KSerializer<BigDecimal>{

    override val descriptor: SerialDescriptor =
        PrimitiveSerialDescriptor("WithCustomDefault", PrimitiveKind.DOUBLE)

    override fun serialize(encoder: Encoder, value: BigDecimal) {
        var dbl:Double? = null;
        console.log("BigDecimalSerializer ",js("typeof value"),value)

        if(value != null) {
            if (js("typeof value == 'string'") && !(value.toString().isBlank())) {
                dbl = "${value}".toDouble()
            } else if (value is BigDecimal) {
                dbl = value.toDouble()
            }
        }
        if(dbl == null){
            encoder.encodeNull()
        }else{
            encoder.encodeDouble(dbl)
        }
    }

    override fun deserialize(decoder: Decoder): BigDecimal {
        return BigDecimal(decoder.decodeDouble())
    }
}
